export interface LocalizedString {
  en: string;
  saEn?: string;
  sanskrit?: string;
}

export function localizedStringFromMap(map: Record<string, unknown>): LocalizedString {
  const saEn = (map['saEn'] ?? map['sanskrit']) as string | undefined;
  const sanskrit = (map['sanskrit'] ?? map['saEn']) as string | undefined;
  return {
    en: map['en'] as string,
    ...(saEn != null && { saEn }),
    ...(sanskrit != null && { sanskrit }),
  };
}
